import React, { useRef, useEffect } from "react";

const ScrambleText = ({ text }) => {
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const textRef = useRef(null);
  let interval = useRef(null);

  const handleMouseEnter = () => {
    let iteration = 0;
    const textElement = textRef.current;
    clearInterval(interval.current);

    interval.current = setInterval(() => {
      textElement.innerText = textElement.innerText
        .split("")
        .map((letter, index) => {
          if (index < iteration) {
            return textElement.dataset.value[index];
          }
          return letters[Math.floor(Math.random() * 26)];
        })
        .join("");

      if (iteration >= textElement.dataset.value.length) {
        clearInterval(interval.current);
      }

      iteration += 1 / 3;
    }, 20);
  };

  useEffect(() => {
    const textElement = textRef.current;
    textElement.addEventListener("mouseenter", handleMouseEnter);
    return () => {
      textElement.removeEventListener("mouseenter", handleMouseEnter);
    };
  }, []);

  return (
    <span className="scramble-text" data-value={text} ref={textRef}>
      {text}
    </span>
  );
};

export default ScrambleText;
